import React, { useState } from "react";
import Swaasa from "../Assets/images/Swaasa Logo.svg";
import LoginEllipse1 from "../Assets/images/login-ellipse-1.svg";
import LoginEllipse2 from "../Assets/images/login-ellipse-2.svg";
import LoginEllipse3 from "../Assets/images/login-ellipse-3.svg";
import GooglePlayStore from "../Assets/images/google-icon.svg";
import AppleIcon from "../Assets/images/apple-icon.svg";
import ClipLoader from "react-spinners/ClipLoader";
import history from "../history";
import "../Assets/styles/newStyles/Login.css";
import axios from "../axios";
import { NotificationManager } from "react-notifications";

const ForgotPassword = () => {
  const [emailError, setEmailError] = useState("");
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const [emailErr, setEmailErr]= useState('')
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [successScreen, setSuccessScreen] = useState(false);

  const goToSupport = () => {
    window.open("https://swaasa.ai/solutions/", "_blank");
  };

  const goToContactUs = () => {
    window.open("https://swaasa.ai/contact-us/", "_blank");
  };
  const goToPrivacyPolicy = () => {
    window.open("https://7jx.d89.myftpupload.com/privacy-policy/", "_blank");
  };

  const goToAppleStore = () => {
    window.open("https://apps.apple.com/us/app/swaasa/id1529923164", "_blank");
  };

  const goToGoogleStore = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.swaasa.app&hl=en&gl=US",
      "_blank"
    );
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailError("");
    setEmailErrorMsg('')
  };

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const sendResetLink = async (e) => {
    e.preventDefault();
  
    if (email === '') {
      setEmailErrorMsg('Please enter your email');
      return;
    }
  
    const emailError = !validateEmail(email) ? 'Enter a valid Email' : '';
    if (emailError) {
      setEmailError(emailError);
      return;
    }
  
    setIsLoading(true);
  
    try {
      const response = await axios.get(`/password_reset/initiate_password_reset/${email}`);
      setIsLoading(false);
      if(response.data.massage==='user not found'){
        setEmailErr('No user found. Please verify the email address.');
        setSuccessScreen(false);
        return
      }
      setSuccessScreen(true);
    } catch (error) {
      setIsLoading(false);
      if (error.response) {
        if (error.response.data.massage === 'user not found') {
          setEmailErr('No user found. Please verify the email address.');
        } else {
          setEmailErr(error.response.data.massage);
        }
      } else if (error.response && error.response.status === 500) {
        setEmailErr('Please try logging in after some time.');
      } else {
        setEmailErr('An unexpected error occurred. Please try again.');
      }
    }
  }; 
  
  const returnToLogin = () => {
    history.push("/");
  };

  return (
    <>
      <div className="main-login-container">
        <div className="header-container">
          <div>
            <img src={Swaasa} className="image-logo" alt="swaasa" />
          </div>
        </div>
        <div className="login-form-container">
          <img src={LoginEllipse2} className="login-ellipse2" alt="ellipse-2" />
          <div style={{ display: "flex" }}>
            {successScreen ? (
              <form className="form-container">
                <h1 className="forgot-heading">Forgot Password</h1>
                <div style={{ marginTop: "10%", textAlign: "center" }}>
                  <h3 style={{ color: "#FF7D00" }}>Email on the way!</h3>
                  <p className="forgot-text" style={{ margin: "5% 0 5% 0" }}>
                  We’ve emailed password reset instructions to
                    <br />
                    <span style={{ fontWeight: "700", fontSize: "15px" }}>
                      {email}
                    </span>
                    . If you don’t see it soon,
                    <br />
                    please check your spam or junk folder.
                  </p>
                  <button
                    className="send-reset-btn"
                    style={{ marginBottom: "0em", marginTop: "10%" }}
                    onClick={returnToLogin}
                  >
                    Go back to Login
                  </button>
                </div>
                <div className="sign-up-forgot">
                  <p className="signup-para" style={{ fontSize: "14px" }}>
                    Didnt't receive mail? 
                    <span style={{ fontWeight: "500", color: "black" }}>
                      Please Contact Us
                    </span>
                  </p>
                </div>
              </form>
            ) : (
              <form className="form-container">
                <h1 className="forgot-heading">Forgot Password ?</h1>
                <p className="forgot-text" style={{ margin: "5% 0 5% 0" }}>
                  Don’t worry. Verify your email to reset the password.
                  <br />
                  You can login again with the newly reset password.
                </p>
                <div className="input-container">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <label className="input-label" htmlFor="username">
                      Enter Email*
                    </label>
                    {emailErrorMsg && <p className="error-email">{emailErrorMsg}</p>}
                    {emailError && !emailErrorMsg&&<p className="error-email">Invalid email format</p>}
                    
                  </div>

                  <input
                    type="text"
                    id="username"
                    name="username"
                    style={
                      emailError
                        ? { color: "var(--Red-Normal, #E63900)" }
                        : { color: "var(--Black, #131313)" }
                    }
                    className="username-input-field"
                    value={email}
                    onChange={handleEmailChange}
                    placeholder="Email/Username"
                    required 
                  />
                  <p className='error-email'>{emailErr}</p>
                </div>
                {isLoading ? (
                  <div
                    className="send-reset-btn"
                    style={{ textAlign: "center", paddingTop: "8px" }}
                  >
                    <ClipLoader color="white" size={25} />
                  </div>
                ) : (
                  <button
                    type="submit"
                    onClick={sendResetLink}
                    className="send-reset-btn"
                    style={{ marginBottom: "0em", marginTop: "10%" }}
                  >
                    Send Reset Link
                  </button>
                )}
                <div className="sign-up-forgot">
                  <p className="signup-para" style={{ fontSize: "14px" }}>
                    Remember Password? {''}
                    <span onClick={returnToLogin} style={{ fontWeight: "500", color: "#FF7D00", cursor:'pointer' }}>
                      Go back to login
                    </span>
                  </p>
                </div>
              </form>
            )}
            <img
              src={LoginEllipse3}
              alt="login-ellipse3"
              className="login-ellipse3"
            />
          </div>

          <img src={LoginEllipse1} className="login-ellipse1" alt="ellipse-1" />
        </div>
        <div className="footer-container">
          <div className="get-containers">
            <div className="get-container">
              <img
                src={GooglePlayStore}
                className="support-image"
                alt="google"
                onClick={goToGoogleStore}
              />
              <img
                src={AppleIcon}
                onClick={goToAppleStore}
                className="support-image"
                alt="apple"
              />
            </div>
          </div>
          <div className="support-containers">
            <h4 className="support-heading" onClick={goToSupport}>
              SUPPORT
            </h4>
            <h4 className="support-heading" onClick={goToContactUs}>
              CONTACT US
            </h4>
            <h4 className="support-heading" onClick={goToPrivacyPolicy}>
              PRIVACY POLICY
            </h4>
            <h4 className="support-heading" onClick={goToPrivacyPolicy}>
              TERMS & CONDITIONS
            </h4>
            {/* <h4 className="support-heading" onClick={goToTermsAndConditions}>TERMS & CONDITIONS</h4> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
